import React from 'react';

export default function ErrorBoundary(props) {


    return <div id="error-boundary">
        <div className="error-boundary-header">
            {/* <img className="imgLogo" src={process.env.PUBLIC_URL + "/portallogo.png"} alt={""} width="368" height="74" /> */}
        </div>
        <div className="error-boundary-body">
            <div className="error-form">
                <div className="k-window-titlebar">
                    <img className="titleLogo" src={process.env.PUBLIC_URL + "/PronexusWorksLogo.ico"} alt="" />
                    <div className="error-title">エラー</div>
                </div>
                <div className="k-window-content" style={{ textAlign: 'center' }}>
                    {props.children}
                </div>
            </div>
        </div>
    </div>
}